const SERVER_URL = "https://server-api-prod.ppshope.com"; // production ★ สลับก่อน build ขึ้น prod ทุกครั้ง!

module.exports = {
  //SERVER_URL: "http://localhost:9999", // local test
  SERVER_URL: "https://server-api-prod.ppshope.com", // production
  // SERVER_URL:"https://server-api-dev.ppshope.com" // dev
  // SERVER_URL:"http://0.0.0.0:8989" // prod
  // SERVER_URL: "https://api.ppshope.com", // prod
  // SERVER_URL: "http://0.0.0.0:7878", // dev
};
